const audioRecordService = {
    getSuitableMimeType() {
        const defaultMimeType = 'audio/webm';
        if (!MediaRecorder?.isTypeSupported) {
            return defaultMimeType;
        }

        const prioritizedAudioMimeTypes = [
            'audio/webm;codecs=opus', // most supported codec
            'audio/webm;codecs=pcm', // second most supported codec
            'audio/webm', // try without codec
            'audio/mp4;codecs=mp4a', // the only one supported by safari v14+
            'audio/mp4', // safari without codec
        ];

        const suitableMimeType = prioritizedAudioMimeTypes.find(MediaRecorder.isTypeSupported);
        return suitableMimeType || defaultMimeType;
    },
};

export default audioRecordService;
